import { ConfigProvider } from 'antd';
import { LangLocale, Language } from 'common/i18n';
import * as React from 'react';
import * as intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import Router from '../Router';
import { RoutesConfig } from '../type';
import Panel from './Panel';
import './style.less';

export { Panel };

interface iProps {
    location?: any;
    lang: Language;
    routesConfig: RoutesConfig;
    name?: string;
    company: any;
}

@(withRouter as any)
export default class Login extends React.Component<iProps> {

    componentDidMount(): void {
        if (document.querySelector("meta[name=viewport]")) {
            document.querySelector("meta[name=viewport]").content = "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0";
        }
    }
    render() {
        const { location, lang, routesConfig, name = '', company } = this.props;
        document.title = `${intl.get('Global.SignIn')} - ${company.company || ''}`;
        return (
            <div className={`Login ${name}`}>
                <ConfigProvider locale={LangLocale[lang]}>
                    <Router location={location} config={routesConfig} />
                </ConfigProvider>
            </div>
        );
    }
}
